import { TODO } from '@b2b/types/core';
import angular from 'angular';

UTCDateFilterFactory.$inject = ['CalendarService', 'dateFilter'];

function UTCDateFilterFactory(CalendarService: TODO, dateFilter: TODO) {
  return function UTCDateFilter(input, format) {
    return input ? dateFilter(CalendarService.parseDate(input), format) : '';
  };
}

export const UTCDateFilterModule = angular
  .module('acme.common.filter.utc-date', [])
  .filter('UTCDate', UTCDateFilterFactory).name;
